import { LeagueView } from "../../View/AppView/LeagueView";
import { ViewController, AuthorityCodeChangeEvent, ModelUpdateEvent, TimeoutEvent, TimeUpdateEvent, MaintenanceEvent, ChannelSwitchEvent } from "@gaming/srvg-classes-core";
import { VideoAreaViewController } from "./VideoAreaViewController";
import { ChunkIndicatorViewController } from "./ChunkIndicatorViewController";
import { ChunkAreaViewController } from "./ChunkAreaViewController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { ChunkRangeChangeEvent } from "../../Event/ChunkRangeChangeEvent";
import { MatchdayPickerLeagueViewController } from "./MatchdayPickerLeagueViewController";

export class LeagueViewController extends ViewController {
    leagueView:LeagueView;
    matchdayPickerLeagueViewController:MatchdayPickerLeagueViewController;
    videoAreaViewController:VideoAreaViewController;
    chunkIndicatorViewController:ChunkIndicatorViewController;
    chunkAreaViewController:ChunkAreaViewController;

    constructor(options) {
        options = options || {};
        options.view = options.leagueView || null;
        super(options);

        this.leagueView = options.leagueView || null;

        /******************* initialize controllers ************************/

        var hasFlash = false;
        // check if flash is available
        try {
            hasFlash = Boolean(new ActiveXObject('ShockwaveFlash.ShockwaveFlash'));
        } catch(exception) {

            hasFlash = ('undefined' != typeof navigator.mimeTypes['application/x-shockwave-flash']);
        }

        // videoView container existing?
        if ( $( "#videoView" ).length ) {
            if(hasFlash || srvg.Player.getWorkingStreamType() === "hls" || srvg.isMobile)
            {
                // initialize
                this.videoAreaViewController = this.addChildViewController( new VideoAreaViewController( { videoAreaView: this.leagueView.videoAreaView } ) );
            }
            else {
                // set warning message
                $('#videoControlbar').hide();
                $('#buttonbarView').hide();
                $('#videoView').addClass('noFlash');
            }
        }

        this.chunkIndicatorViewController = this.addChildViewController(new ChunkIndicatorViewController({
            chunkIndicatorView: this.leagueView.chunkIndicatorView
        }));

        if (srvg && srvg.config && srvg.config.modeItaly === true){
            app.timelineController.addSubscriberForEvent(this.chunkIndicatorViewController, AuthorityCodeChangeEvent);
        }


        /*this.overlayViewController    = this.addChildViewController( new OverlayViewController( {
         overlayView: this.webView.overlayContainerView,
         teamAssignmentFeed: new JsonFeed( { url: srvg.url.teamJerseyAssignment } ),
         teamResultFeed: new JsonFeed( { url: srvg.url.teamResult } )
         } ) );
         */
        this.chunkAreaViewController = this.addChildViewController(new ChunkAreaViewController({
            useChunkModel: true,
            chunkAreaView: this.leagueView.chunkAreaView
        }));

        // add matchday picker controller
        this.matchdayPickerLeagueViewController = this.addChildViewController(new MatchdayPickerLeagueViewController(
            {}
        ));
        /******************* connect components ************************/

        if (this.leagueView.chunkAreaView.chunkPickerView) {
            // FIXME move
            this.leagueView.chunkAreaView.selectedChunkModel.addSubscriberForEvent(
                app.customerIntegrationController,
                ModelUpdateEvent
            );
        }

        app.timelineController.addSubscriberForEvent(srvg.maintenance, MaintenanceEvent);
        app.timelineController.addSubscriberForEvent(app.customerIntegrationController, PhaseChangeEvent);
        app.timelineController.addSubscriberForEvent(this.chunkIndicatorViewController, PhaseChangeEvent);
        app.timelineController.addSubscriberForEvent(app.server, TimeUpdateEvent);
        /*app.timelineController.addSubscriberForEvent( this.overlayViewController, PhaseChangeEvent );*/
        app.timelineController.addSubscriberForEvent(this.chunkAreaViewController, ChunkRangeChangeEvent);

        // subscribe for ChunkChangeEvents
        app.timelineController.addSubscriberForEvent(this.matchdayPickerLeagueViewController, PhaseChangeEvent);
        app.timelineController.addSubscriberForEvent( this, PhaseChangeEvent );

        // subscribe all necessary controller and other for inactivity
        if( app.inactivityController ) {
            app.inactivityController.addSubscriberForEvent(app.server, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.chunkAreaViewController, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.leagueView.tickerWidget, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.leagueView.livescoreWidget, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.leagueView, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.matchdayPickerLeagueViewController, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.chunkIndicatorViewController, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.videoAreaViewController, TimeoutEvent);
        }

        /*
         this.guiSwitchController.addSubscriberForEvent( app.customerIntegration, GuiResizeEvent );
         */
        var exch = srvg.eventExchange;
        /*
         if( srvg.widgets[Widgets.WIDGET_LIVETABLE].enabled ) {
         this.guiSwitchController.addSubscriberForEvent(this.liveTableController, GuiSwitchEvent);
         this.webView.liveTable.addSubscriberForEvent(this.liveTableController, RelayoutEvent);
         }
         if( srvg.widgets['livesettlements'].enabled){
         this.liveSettlementsViewController = this.addChildViewController(
         new LiveSettlementsViewController({livesettlementWidget: this.webView.widgetLivesettlements})
         );
         this.guiSwitchController.addSubscriberForEvent(this.liveSettlementsViewController, GuiSwitchEvent);
         }
         */
        exch.addEventHandler(app.timelineController, 'all', ChannelSwitchEvent);

        /*exch.addEventHandler(this.overlayViewController,       'all',                          ChannelSwitchEvent );*/
        exch.addEventHandler(app.customerIntegrationController, 'all', ChannelSwitchEvent);

        if( srvg.debugView ) {
            srvg.debugView.registerEventHandlers();
        }

        /******************* start components ************************/
        app.timelineController.startPolling();
        if( app.inactivityController ) {
            app.inactivityController.startWaiting();
        }
        app.customerIntegrationController.startCustomerActions();
    }

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        this.leagueView.$domNode.attr('data-phase-name', event.phase.name);
    }

    // stop/disable all functions except of widgets and inactivitybutton
    handleTimeoutEvent(event: TimeoutEvent, provider){
        setTimeout(function() {
            srvg.eventExchange.eventSubscriptions = [];
        }, 2000);
    }
}